/** Pure formatting for the recovery-code download, so what lands in the file
 *  is testable without a fixture. */

/**
 * The body of the downloaded `.txt`: header, date, then one code per line.
 *
 * Nothing identifying the account goes in — helpful right up until the file
 * leaks, at which point it tells the finder where to spend the codes.
 */
export function formatRecoveryCodesFile(
  codes: string[],
  meta: { header: string; generatedAt: string }
): string {
  const lines = [meta.header, meta.generatedAt, '', ...codes];
  return `${lines.join('\n')}\n`;
}

/** `volta-recovery-codes-YYYY-MM-DD.txt`. */
export function recoveryCodesFilename(now: Date): string {
  const pad = (value: number): string => String(value).padStart(2, '0');
  const stamp = [
    now.getFullYear(),
    pad(now.getMonth() + 1),
    pad(now.getDate()),
  ].join('-');
  return `volta-recovery-codes-${stamp}.txt`;
}
